const InfoRow = ({ label, value }) => (
    <tr className="text-[12px] sm:text-sm">
        <td className="px-4 py-3 font-medium text-gray-600 w-1/3 ">
            {label}
        </td>

        <td className="px-4 py-3 text-gray-800 text-right zx:text-left">
            {value || "-"}
        </td>
    </tr>
);

export default function PreviewLead({ editingLead, formatPhone }) {
    if (!editingLead) return null;

    return (
        <div className="w-full bg-white rounded-xl shadow-md border border-gray-200 p-6 mt-6">

            <div className="mb-5 border-b pb-3">
                <h2 className="text-[14px] sm:text-[16px] font-semibold text-gray-800">
                    Lead Details
                </h2>
            </div>

            <div className="mb-8">
            <h3 className="text-[13px] sm:text-[15px] font-semibold text-gray-700 mb-3">
                    Client Information
                </h3>

                <div className="border rounded-lg overflow-hidden">
                    <table className="w-full border-collapse">
                        <tbody className="divide-y ">
                            <InfoRow label="Lead Owner" value={editingLead.leadOwner} />
                            <InfoRow
                                label="Client Name"
                                value={`${editingLead.firstName || ""} ${editingLead.lastName || ""}`}
                            />
                            <InfoRow label="Email" value={editingLead.email} />
                            <InfoRow label="Phone" value={formatPhone(editingLead.phone)} />
                            <InfoRow
                                label="Applied Date"
                                value={new Date(editingLead.createdAt).toLocaleDateString()}
                            />
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Address Info */}
            <div>
                <h3 className="text-[13px] sm:text-[15px] font-semibold text-gray-700 mb-3">
                    Address Information
                </h3>

                <div className="border rounded-lg overflow-hidden">
                    <table className="w-full border-collapse">
                        <tbody className="divide-y divide-gray-200">
                            <InfoRow label="Country / Region" value={editingLead.address?.country} />
                            <InfoRow label="City" value={editingLead.address?.city} />
                            <InfoRow label="Time Zone" value={editingLead.address?.timeZone} />
                            <InfoRow label="Zip Code" value={editingLead.address?.zip} />
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
}